import round from 'lodash/round';
import { func, number, string } from 'prop-types';
import React from 'react';

import CurrencyInput from '../../../generic/CurrencyInput';
import getDatasetFromProps from '../../../utils/get-dataset-from-props';
import { calculateBudget } from '../calculate-derived-values';

class DerivedCurrencyInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: calculateBudget(props.share, props.budget),
      share: props.share,
      budget: props.budget,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.share !== props.share || state.budget !== props.budget) {
      return {
        value: calculateBudget(props.share, props.budget),
        share: props.share,
        budget: props.budget,
      };
    }
    return null;
  }

  handleChange(event) {
    this.setState({ value: event.target.value || 0 });
  }

  handleBlur() {
    const { name, share, budget, onChange } = this.props;
    const currencyValue = this.state.value;
    const value = !currencyValue ? 0 : round(currencyValue / budget, 4);

    if (value === share) {
      this.setState({ value: calculateBudget(share, budget) });
      return;
    }

    const syntheticEvent = {
      target: {
        value,
        name,
        type: 'derived-currency',
        dataset: getDatasetFromProps(this.props),
      },
    };
    onChange(syntheticEvent);
  }

  render() {
    const { share, budget, onChange, ...rest } = this.props;
    return (
      <CurrencyInput
        value={this.state.value}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        {...rest}
      />
    );
  }
}

DerivedCurrencyInput.propTypes = {
  share: number.isRequired,
  budget: number.isRequired,
  name: string,
  onChange: func,
};

DerivedCurrencyInput.defaultProps = {
  onChange: () => {},
  name: '',
};

export default DerivedCurrencyInput;
